export default __webpack_public_path__ + "static/benefitSectionBg-14a3beee7a6121a0897f5369871c6ad3.png";